module.exports = __webpack_public_path__ + "files/77b3cbeaa6d5b4cfecf78c366ce7e257.mp3";